import { render } from "./UtvonalMap.vue?vue&type=template&id=b708fc62&scoped=true"
import script from "./UtvonalMap.vue?vue&type=script&lang=js"
export * from "./UtvonalMap.vue?vue&type=script&lang=js"

import "./UtvonalMap.vue?vue&type=style&index=0&id=b708fc62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b708fc62"]])

export default __exports__